import React from "react";

function IconBtnNoTooltip(props) {
  return (
    <button
      className={`${props.className} `}
      disabled={props.disabled}
      type={props.type}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export default IconBtnNoTooltip;
